import type { Theme } from '@mui/material/styles/createTheme';

export const getMixedColor = (theme: Theme): string => theme.customPalette.panels.side.font;
